import React, {useState} from 'react'
import {Button, Input, message} from 'antd'
import {Link, redirect, useNavigate} from 'react-router-dom'
import {instance as userService} from '../../services/UserService'
import {useIntl} from 'react-intl'
import './loginPage.less'
import {emailRegexp} from './util'

export function ResetPasswordPage() {
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  const [isEmailSent, setEmailSent] = useState(false)
  const [email, setEmail] = useState('')

  const intl = useIntl()

  const isEmailValidated = emailRegexp.test(email)

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="container">
        <Link className="logo" to="/">
          <h1>TerraSketch</h1>
        </Link>
        <h2>{intl.formatMessage({id: 'resetPassword'})}</h2>
        {isEmailSent ? (
          <div className="email-check">
            <div>{intl.formatMessage({id: 'checkYourEmail'})}</div>
            <Button
              size="large"
              type="primary"
              onClick={async () => {
                navigate('/login')
              }}
            >
              {intl.formatMessage({id: 'ok'})}
            </Button>
          </div>
        ) : (
          <div className="reset-email">
            <span>{intl.formatMessage({id: 'enterResetEmail'})}</span>
            <Input
              className="reset-email__input"
              placeholder="email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />

            <Button
              size="large"
              type="primary"
              disabled={email === '' || !isEmailValidated}
              onClick={async () => {
                const result = await userService.resetPassword(email)
                if (!result.success) {
                  messageApi.open({
                    type: 'error',
                    content: result.error.message,
                  })
                } else {
                  setEmailSent(true)
                }
              }}
            >
              {intl.formatMessage({id: 'sendEmailToResetPassword'})}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
